export enum pageNavigationRoutes {
  MANAGEMENT = '/management',
  QUESTIONNAIRES = '/questionnaires',
  ROLES = '/roles',
}
